import { Directive } from '@angular/core';

@Directive({
    selector: '[appLink]',
    host: {
        class: 'link link-primary',
    },
})
export class AppLinkDirective {}
